import { render } from "./HomeView.vue?vue&type=template&id=fa63f57c&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__